import Head from 'next/head'
import { useLayoutEffect } from 'react'

interface PageTitleProps {
  children: string
}

export function PageTitle({ children }: PageTitleProps) {
  // Next's pages-router announcer reads document.title in a passive effect.
  // Set it during layout so locale changes announce the new language's title.
  useLayoutEffect(() => {
    document.title = children

    // A locale's resources can resolve just after Next announces a route.
    // If Next has already announced this navigation, replace the stale title;
    // leave its empty initial-load announcer alone to avoid a duplicate read.
    const routeAnnouncer = document.getElementById('__next-route-announcer__')
    if (routeAnnouncer?.textContent) {
      routeAnnouncer.textContent = children
    }
  }, [children])

  return (
    <Head>
      <title>{children}</title>
    </Head>
  )
}
